var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58169 0 0 3.58169 0 8C0 12.4183 3.58169 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58169 12.4183 0 8 0Z",
    fill: "#40B3E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8929 4.60193L10.464 11.8062C10.464 11.8062 10.2641 12.3059 9.71459 12.0661L6.41721 9.53806L5.21821 8.95856L3.19984 8.27906C3.19984 8.27906 2.89009 8.16918 2.86009 7.92937C2.83009 7.68956 3.20984 7.55968 3.20984 7.55968L11.2333 4.41218C11.2333 4.41218 11.8928 4.12243 11.8928 4.60206",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1634 11.7252C6.1634 11.7252 6.06715 11.7162 5.94715 11.3365C5.82734 10.9568 5.21777 8.95842 5.21777 8.95842L10.0639 5.88092C10.0639 5.88092 10.3437 5.71104 10.3337 5.88092C10.3337 5.88092 10.3836 5.91092 10.2337 6.05079C10.0839 6.19073 6.42684 9.47804 6.42684 9.47804",
    fill: "#D2E5F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68126 10.5071L6.37707 11.6962C6.37707 11.6962 6.27507 11.7736 6.16357 11.7251L6.41332 9.51636",
    fill: "#B5CFE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.8757ad48cda876cc5e748ddedf9b3fec.svg";
export { ForwardRef as ReactComponent };